<template>
  <Modal :header="header" header-class="fs-4" @close="$emit('close')">
    <div class="flex-1 flex flex-col">
      <div class="last:mb-0" v-if="result && result.error">
        <p>Oops, something went wrong. Please try again.</p>
      </div>
      <template v-else-if="result || searching">
        <KeywordResultsItem
          v-for="(r, index) in result || 10"
          :key="index"
          :keyword-result="result && r"
          @click.native="onResultItemClick(index)"
        />
      </template>
      <div class="p-4 m-auto text-center text-gray-600" v-else-if="searchValue">
        <p>No keyword results found for {{ searchValue }}</p>
      </div>
    </div>
  </Modal>
</template>

<script>
import KeywordResultsItem from "@/views/Home/KeywordResults/Item";
import Modal from "@/views/Home/Modal";

export default {
  name: "KeywordResultsModal",
  components: {
    KeywordResultsItem,
    Modal,
  },
  props: {
    result: Array,
    searching: Boolean,
    searchValue: String,
  },
  computed: {
    header() {
      return `Choose a domain for keyword search "${this.searchValue}"`;
    },
  },
  methods: {
    onResultItemClick(index) {
      if (this.result) this.$emit("result-selected", index);
    },
  },
};
</script>
